<script lang="ts" setup>
import { Co2QuizAnswer, Co2QuizQuestion } from '@/models/co2-quiz.model';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, watch } from 'vue';
import { useStore } from 'vuex';
import {
  Co2QuizStoreActions,
  Co2QuizStoreMutations,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import Co2Question from '@/components/co2quiz/Co2Question.vue';
import { SimpleUserCo2QuizAnswer } from '@/models/user.model';
import Co2QuizResults from '@/components/co2quiz/Co2QuizResults.vue';

const store = useStore<ShiftCMSState & { co2: Co2QuizStoreState }>();
const questions = computed<Co2QuizQuestion[]>(() => store.state.co2.questions);
const answers = computed<SimpleUserCo2QuizAnswer[]>(
  () => store.state.co2.answers,
);

watch(
  () => answers.value,
  () => {
    store.dispatch(Co2QuizStoreActions.UpdateResults, answers.value);

    store.commit(Mutations.ShowSubDrawer, {
      component: markRaw(Co2QuizResults),
      data: questions,
      small: true,
    });
  },
);

const followQuestions = computed<number[]>(() =>
  questions.value.reduce((acc: number[], i: Co2QuizQuestion) => {
    const followUps: Co2QuizQuestion[] = i.answers
      .filter((a) => a.followUpQuestion)
      .map((a) => a.followUpQuestion)
      .filter((n) => !!n);
    return [...acc, ...followUps.map((f) => f.id)];
  }, []),
);

function showResults() {
  //
}

function selectAnswer(
  question: Co2QuizQuestion,
  answer: Co2QuizAnswer | null,
  inputValue?: string,
) {
  store.commit(Co2QuizStoreMutations.UpdateAnswer, {
    question,
    answer,
    inputValue,
  });
}

function reset() {
  store.commit(Co2QuizStoreMutations.ResetAnswers);
  store.commit(Mutations.HideSubDrawer);
}
</script>
<template>
  <v-form @submit.prevent="showResults">
    <v-container>
      <div
        style="
          display: flex;
          flex-direction: row;
          padding-right: 64px;
          margin-bottom: 16px;
        "
      >
        <h2>Co2 Calculator</h2>
        <v-spacer /> <v-btn color="warning" @click="reset">Reset</v-btn>
      </div>

      <Co2Question
        v-for="q in questions"
        :question="q"
        :selected="answers.find((a) => a.question.id === q.id) || null"
        :followups="followQuestions"
        :key="q.id"
        @update:answer="
          ({ answer, inputValue }) => selectAnswer(q, answer, inputValue)
        "
      />
    </v-container>
  </v-form>
</template>
